module.exports = __webpack_public_path__ + "media/23.63167de7.mp3";